'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.user = exports.snackBar = exports.loader = exports.theme = exports.i18n = exports.form = exports.routing = undefined;

var _reactRouterRedux = require('react-router-redux');

Object.defineProperty(exports, 'routing', {
  enumerable: true,
  get: function get() {
    return _reactRouterRedux.routerReducer;
  }
});

var _reduxForm = require('redux-form');

Object.defineProperty(exports, 'form', {
  enumerable: true,
  get: function get() {
    return _reduxForm.reducer;
  }
});

var _reducer = require('@its/components/lib/Container components/IntlProviderContainer/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = require('@its/components/lib/Container components/MuiThemeProviderContainer/reducer');

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = require('@its/components/lib/Container components/LoadingContainer/reducer');

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = require('@its/components/lib/Container components/SnackBarContainer/reducer');

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = require('@its/components/lib/Container components/UserContainer/reducer');

var _reducer10 = _interopRequireDefault(_reducer9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.i18n = _reducer2.default;
exports.theme = _reducer4.default;
exports.loader = _reducer6.default;
exports.snackBar = _reducer8.default;
exports.user = _reducer10.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/reducers.js
 ** module id = 508
 ** module chunks = 0
 **/